import { ChangeDetectionStrategy, Component, HostListener, inject, signal, WritableSignal } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faSquareArrowUp } from "@fortawesome/pro-light-svg-icons";
import { NotifyChipComponent } from "../notify-chip/notify-chip.component";
import { NotifyChipValueComponent } from "../notify-chip/components/notify-chip-value/notify-chip-value.components";
import { IconModule } from "@ogs/ngx-m3-components";
import { TranslationPipeModule } from "@ogs-gmbh/ngx-translate";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-shared-caps-lock-notice",
  templateUrl: "./caps-lock-notice.component.html",
  styleUrl: "./caps-lock-notice.component.scss",
  standalone: true,
  imports: [
    NotifyChipComponent,
    NotifyChipValueComponent,
    IconModule,
    TranslationPipeModule
  ],
  providers: [
    FaIconLibrary
  ]
})
export class CapsLockNoticeComponent {
  private readonly faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  protected readonly isCapsLockOn: WritableSignal<boolean> = signal<boolean>(false);

  @HostListener("window:keydown", [ "$event" ])
  checkCapsLock (keyboardEvent: KeyboardEvent): void {
    this.isCapsLockOn.set(keyboardEvent.getModifierState("CapsLock"));
  }

  constructor () {
    this.faIconLibrary.addIcons(faSquareArrowUp);
  }
}
